import React, { useState } from 'react'
import Card from '../../common/card/card'
import { Tooltip } from 'antd'
import noImage from '../../../assets/images/noImage.jpg'
import './imageCard.scss' // SCSS file

const ImageCard = ({ data, onImageClick = () => {} }) => {
  const [imgSrc, setImgSrc] = useState(data.imageUrl || noImage)

  return (
    <Card hoverable bordered={false} className="image-card">
      <Tooltip title="Product Image" placement="top">
        <img
          alt="Product"
          src={imgSrc}
          onError={() => setImgSrc(noImage)}
          onClick={() => onImageClick(data.imageUrl, imgSrc)}
          className="product-image"
        />
      </Tooltip>
    </Card>
  )
}

export default ImageCard
